// Version: 0.0.1
// Author : VAIBAV
// MODIFIED DATA : 23-12-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

// Get Collection Format Report Details

export const getCollectionFormatReportDetails = (fetchData: any) => {
	const data = {
		GetCollectionFormatReportDetailsToken: fetchData,
	};
	const url = `${API_URL}PostAccuredInterestReport`;
	return makeApiCall(url, data);
};
